// extracted by mini-css-extract-plugin
export default {"accordionTab":"b2244594b38743dd","accordionTabTitle":"_180c8caeaaca23cd","accordionTabBody":"_70cc73833b6ce510","accordionTabOpen":"_3b709bd5bcc0c138"};